import { TipoPergunta } from './enum';

export class VendaPergunta {
  id: number;
  descricao: string;
  tipoDescricao: string;
  tipo: TipoPergunta;
  respostaSN?: string;
  respostaTexto: string;
  tipoQuest: number;
  status: number;
}
